export default __webpack_public_path__ + "static/media/white_brawn.a0e88577.png";